// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__2lXEB","title404":"NotFound_title404__lB6o7","message":"NotFound_message__dU56I"};